import BaseDialog from '@/components/BaseDialog';
import { batchSelectModal } from '@/components/modal'

/**
 * 温馨提示
 * @param {*} param0
 * @returns
 */
export function messageTipModal({ cbs, props }) {
    return new BaseDialog({
        component: ()=>import('./messageTipModal'),
        options: {
            width: '500px',
            title: '温馨提示',
            'close-on-press-escape': false,
            'close-on-click-modal': false,
            'show-close': false,
        },
        props,
        cbs,
    })
}

export function messageTabelModal({ cbs, props }) {
    return new BaseDialog({
        component: ()=>import('./messageTabelModal'),
        options: {
            width: '800px',
            title: '温馨提示',
            'close-on-press-escape': false,
            'close-on-click-modal': false,
            'show-close': false,
        },
        props,
        cbs,
    })
}




export function infoMoal({ cbs, props,on }) {
    return new BaseDialog({
        component: ()=>import('./info'),
        options: {
            width: '75%',
            title: '详情',
            wrapperClosable: false,
            'close-on-press-escape': false,
            'close-on-click-modal': false,
            top: '100px'
        },
        props,
        cbs,
        on,
    })
}
/**
 * 批量选择刷选内容
 * @param {*} param0
 * @returns
 */
export function screenBatchSelectModal({ cbs }) {
    return batchSelectModal({
        title: '批量选择',
        props: {
            tip: '输入或粘贴名称/ID，每行一个',
            hasLoading: true
        },
        cbs
    })
}
